import { jsxs as l, jsx as c } from "react/jsx-runtime";
const i = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ c("g", { clipPath: "url(#big_commerce-colored_svg__a)", children: /* @__PURE__ */ l("g", { fill: "#34313F", clipPath: "url(#big_commerce-colored_svg__b)", children: [
        /* @__PURE__ */ c("path", { d: "M12.653 13.663h3.03c.861 0 1.406-.473 1.406-1.235 0-.718-.545-1.235-1.406-1.235h-3.03c-.1 0-.186.086-.186.173v2.125c.013.1.085.172.186.172m0 4.895h3.13c.962 0 1.536-.488 1.536-1.35 0-.746-.545-1.349-1.536-1.349h-3.13c-.1 0-.186.086-.186.173v2.34c.013.115.085.186.186.186" }),
        /* @__PURE__ */ c("path", { d: "m23.737.053-8.96 8.93h1.465c2.283 0 3.633 1.436 3.633 3 0 1.236-.833 2.14-1.724 2.542-.143.058-.143.259.015.316 1.033.402 1.765 1.479 1.765 2.742 0 1.78-1.191 3.2-3.503 3.2h-6.345c-.1 0-.186-.085-.186-.172v-6.762L.062 23.64c-.13.13-.044.36.144.36H23.85a.16.16 0 0 0 .159-.159V.182c.042-.158-.159-.244-.273-.129" })
      ] }) }),
      /* @__PURE__ */ l("defs", { children: [
        /* @__PURE__ */ c("clipPath", { id: "big_commerce-colored_svg__a", children: /* @__PURE__ */ c("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }),
        /* @__PURE__ */ c("clipPath", { id: "big_commerce-colored_svg__b", children: /* @__PURE__ */ c("path", { fill: "#fff", d: "M0 0h24.015v24H0z" }) })
      ] })
    ]
  }
);
export {
  i as default
};
